import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { PrismicNextImage } from '@prismicio/next';
import { PrismicRichText } from '@prismicio/react';
import { PrismicNextLink } from '@prismicio/next';
import { PlainRightArrow } from '@/assets/PlainRightArrow';

/**
 * Props for `MediaTextGrid`.
 */
export type MediaTextGridProps =
  SliceComponentProps<Content.MediaTextGridSlice>;

/**
 * Component for "MediaTextGrid" Slices.
 */
const MediaTextGrid = ({ slice }: MediaTextGridProps): JSX.Element => {
  const {
    primary: {
      main_image: mainImage,
      secondary_image_1: secondaryImage1,
      secondary_image_2: secondaryImage2,
      title,
      description,
      cta_button: ctaButton,
      cta_label: ctaLabel,
    },
  } = slice;
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="px-12 lg:py-14 bg-white"
    >
      <div className="container mx-auto p-4 md:px-6 text-black">
        <div className="flex flex-col md:flex-row items-start gap-x-8 lg:gap-x-8">
          <div className="w-full flex flex-col items-start gap-y-4 md:gap-y-6 mb-8 md:mb-0 md:max-w-[32rem]">
            <div className="w-full overflow-hidden">
              <PrismicNextImage field={mainImage} />
            </div>

            <div className="w-full flex flex-row items-stretch gap-x-4 md:gap-x-2">
              <div className="w-1/2 h-20 md:h-40 overflow-hidden">
                <PrismicNextImage
                  field={secondaryImage1}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-1/2 h-20 md:h-40 overflow-hidden">
                <PrismicNextImage
                  field={secondaryImage2}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* center these horizontally */}
          <div className="h-full w-full md:w-1/2 flex flex-col items-start text-left gap-y-5 md:gap-y-7 md:py-32">
            <div
              style={{
                fontWeight: '700',
                fontSize: '40px',
                lineHeight: '120%',
              }}
            >
              <PrismicRichText field={title} />
            </div>
            <div
              style={{
                fontWeight: '400',
                fontSize: '18px',
                lineHeight: '150%',
              }}
            >
              <PrismicRichText field={description} />
            </div>
            <PrismicNextLink
              field={ctaButton}
              className="button-squared"
              style={{
                backgroundColor: '#03BF9E',
              }}
            >
              <div className="flex flex-row gap-x-7">
                <span>{ctaLabel}</span>
                <PlainRightArrow fill="white" arrowFill="white" />
              </div>
            </PrismicNextLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaTextGrid;
